import MuiAvatar from "@mui/material/Avatar";
import MuiListItemAvatar from "@mui/material/ListItemAvatar";
import ListItemText from "@mui/material/ListItemText";
import MenuItem from "@mui/material/MenuItem";
import { styled } from "@mui/material/styles";
import * as React from "react";
import { useNavigate } from "react-router-dom";

const Avatar = styled(MuiAvatar)(({ theme }) => ({
  width: 28,
  height: 28,
  backgroundColor: (theme.vars || theme).palette.background.paper,
  color: (theme.vars || theme).palette.text.secondary,
  border: `1px solid ${(theme.vars || theme).palette.divider}`,
}));

const ListItemAvatar = styled(MuiListItemAvatar)({
  minWidth: 0,
  marginRight: 12,
});

export default function Logo({ orientation, clickable = false }) {
  const navigate = useNavigate();

  return (
    <MenuItem
      value=""
      sx={{
        display: "flex",
        flexDirection: orientation === "horizontal" ? "row" : "column",
        gap: 1,
      }}
      onClick={() => {
        if (clickable) navigate("/dashboard");
      }}
    >
      <ListItemAvatar>
        <Avatar
          alt="ENJO'NE logo"
          src="/logo.png"
          sx={{ width: "40px", height: "40px" }}
        />
      </ListItemAvatar>
      <ListItemText primary="ENJO'NE Admin Portal" />
    </MenuItem>
  );
}
